import { useCallback, useState } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';
import { CurrentUserInfo } from 'types/';
// import { getNewRelicAgent } from './useNewRelic';

// Create a singleton instance to store the result data across components
let userResultData:
  | { data: CurrentUserInfo }
  | { error: FetchBaseQueryError | SerializedError }
  | undefined;

/**
 * Hook for storing and accessing user result data across components
 * Automatically saves user ID to New Relic when full user information is fetched
 */
export const useUserResultData = () => {
  // Get the current value
  const [resultUserData, setResultUserData] =
    useState<typeof userResultData>(userResultData);

  // Update both the local state and the singleton value
  const updateUserResultData = useCallback(
    (newResultData?: typeof userResultData) => {
      // Update singleton value
      userResultData = newResultData;

      // Update local state
      setResultUserData(newResultData);
    },
    []
  );

  // Extract and store the entire result data
  const extractUserResultData = useCallback(
    (result: any) => {
      // Update the result data
      updateUserResultData(result as typeof userResultData);

      // Send user ID information to New Relic if data exists
      // if ('data' in result && result.data?.id) {
      //   getNewRelicAgent()
      //     .then((newrelic) => {
      //       if (newrelic?.setCustomAttribute) {
      //         // Set user ID as custom attribute for New Relic tracking
      //         console.log('Setting user ID to New Relic:', result);
      //         newrelic.setCustomAttribute('userId', result.data.id);
      //       }
      //     })
      //     .catch((error) => {
      //       // Silently handle New Relic errors to avoid disrupting the main flow
      //       // eslint-disable-next-line no-console
      //       console.debug('New Relic tracking error:', error);
      //     });
      // }

      return result;
    },
    [updateUserResultData]
  );

  return {
    resultUserData,
    updateUserResultData,
    extractUserResultData,
  };
};
